/*
Carlos M:
for promo pages, VIN, Students and VSPN
*/

import $j from 'jquery';
import MobileDetect from 'mobile-detect';
import React from 'react';
import ReactDOM from 'react-dom';
import Anime from 'animejs';
//import ImageMap from 'image-map';
// looks like webpack is having an issue importing and bundling 'image-map'
// so referencing as project file rather than module for now
import ImageMap from './globals/ImageMap';
import { scrn_md, $docContainer, $header, $promoPageNavLinks, CurrentPage, managedOverflowClass, noOverFlowClass, mainNav } from './globals/ProjectVars';
import * as HeaderUtils from './globals/HeaderUtils';
/*
import * as ATHToken from './globals/ATHToken';
import { ATHCompatible } from './globals/ATHCompatible';
*/
import { AddToHomeScreen } from './components/AddToHomeScreen';
import { Testimonials } from './components/testimonials/Testimonials';
import { ModalWrapper } from './components/modals/ModalWrapper';
import { QuickLinksModal } from './components/modals/QuickLinksModal';
import { RandomBanner } from './components/RandomBanner/RandomBanner';

// styles
import '../assets/css/fonts/fonts.css';
import '../../../../../../../VINGlobal/Global/CSS/Proud2BaVINner.css'; // hahaha, that path though 
import '../assets/css/base.css';

// VIN global js
import handleP2BLinks from 'handleP2BLinks';

//----------------------------------------------------------------------------------//

$j(document).ready(() => {
    // scoped 'Global' vars //
    // Carlos M: using in sliders.js to determine if a con page and if so what type - added 7 / 05 / 2017 for tfs#12321
    const theUrl = window.location.href;
    const hashOnPageLoad = window.location.hash;

    // global var to help manage opened windows
    let tempWindow = null;

    //let a2hsSupport = false;
    MobileDetect;
    const device = new MobileDetect(window.navigator.userAgent);
    const likelyMobile = device.mobile();

    let promoPageNavLinks_visible = false;

    let is_lgScreen;

    let qlModalDisplayed = false;
    let VINdex_cache = null;
    // end scoped 'Global' vars //

    //----------------------------------------------------------------------------------//

    // Document and/or Window stuff //
    $docContainer.addClass(managedOverflowClass);

    checkViewSize();
    $j(window).resize(checkViewSize);
    $docContainer.resize(checkViewSize);

    //Carlos M: adding dropshadow/border to header if page is scrolled
    $j(window).scroll(scrollFn);
    $docContainer.scroll(scrollFn);

    // managing jumplinks to account for fixed header if hash in url on page load
    if (hashOnPageLoad && hashOnPageLoad !== undefined && hashOnPageLoad !== '#') {
        (function () {
            var $jumpLocation = $j('#' + hashOnPageLoad.substr(1));
            if ($jumpLocation.length > 0) jumpToLink(hashOnPageLoad.substr(1));
        }());
    }

    // end Document and/or Window stuff //

    //----------------------------------------------------------------------------------//

    // all pages //

    //Carlos M: updating current date where needed
    $j('.crYear').html(new Date().getFullYear());

    // manage emails to reduce spam
    $j('.email').click(e => e.target.getAttribute('data-domain').toLowerCase() == 'ivalalearn' ? openEmailClient(e) : goToContactPage(e));

    //managing in page jumplinks to account for fixed header
    $j('a[href*="#"]').click(function (event) {
        var jumpTarget = $j(this).attr('href').split('#').pop();
        if (jumpTarget && $j('#' + jumpTarget).length > 0) {
            event.preventDefault();            
            jumpToLink($j('#' + jumpTarget).attr('id'));
            return false;
        }
    });

    //admin edit link
    $j('.admin.edit').click(function(evt) {
        evt.preventDefault();
        EditDocument(this.href);
    });

    // quick links button handler
    const qlBtns = Array.from(document.querySelectorAll('.btnQuickLinks'));
    if (qlBtns && qlBtns.length > 0) {
        const qlModalContainer = document.createElement('div');
        const navLead = document.querySelector('#mainNav .navLead');

        if (navLead) {
            navLead.appendChild(qlModalContainer);
        }
        else {
            mainNav.appendChild(qlModalContainer);
        }

        const toggleQLModal = () => {
            console.log('toggleQLModal called, qlModalDisplayed?', qlModalDisplayed);
            if (qlModalDisplayed) {
                ReactDOM.unmountComponentAtNode(qlModalContainer);
            } 
            else {
                ReactDOM.render(
                    <ModalWrapper modalRoot={mainNav}>
                        <QuickLinksModal
                            showQL={true}
                            handleHideQL={toggleQLModal}
                            updateVINdexCache={(data) => VINdex_cache = data}
                            dataCache={VINdex_cache}
                        />
                    </ModalWrapper>,
                    qlModalContainer
                );
            }
            qlModalDisplayed = !qlModalDisplayed;
        };

        qlBtns.forEach(qlBtn => qlBtn.addEventListener('click', evt => {
            evt.preventDefault();
            toggleQLModal();
        }));
    }

    // Main nav //

    //Carlos M: determining page and adding 'active' class to appropriate nav anchors
    (function () {
        var activeLink = null;

        switch (CurrentPage) {
            case 'homePage':
                activeLink = 'Home';
                break;
            case 'aboutPage':
                activeLink = 'About';
                break;
            case 'aboutVINPage':
                activeLink = 'About VIN';
                break;
            case 'membershipPage':
                activeLink = 'Membership';
                break;
            case 'familyPage':
                activeLink = 'VIN Family';
                break;
            case 'friendsPage':
                activeLink = 'Friends of VIN';
                break;
            case 'contactPage':
                activeLink = 'Contact';
                break;
            case 'whyPage':
                activeLink = 'Why VIN';
                break;
            case 'resourcesPage':
                activeLink = 'Resources';
                break;
            case 'aboutCEPage':
                activeLink = 'CE';
                break;
            case 'friendsVSPNPage':
                activeLink = 'Friends of VIN/VSPN';
                break;
            case 'facResPage':
                activeLink = 'Faculty and Residents';
                break;
            case 'recGradPage':
                activeLink = 'Recent Graduates';
                break;
            case 'proudVINnerPage':
                activeLink = 'Proud to be a VINner!';
                break;
            case 'proudVINner2Page':
                activeLink = 'Proud to be a VINner!';
                break;
        }

        makeNavItemActive(activeLink);
    }());

    //mobile menu button, open/close main nav
    $j('.navLead .menuControl').on({
        click: function (event) {
            event.preventDefault();
            if (!is_lgScreen) {
                toggleMainNav();
            }
        }
    });

    //when mobile menu is open, functionality for close buttons
    $promoPageNavLinks.find('[data-dismiss="' + $promoPageNavLinks.attr('id') + '"]').on({
        click: function (event) {
            event.preventDefault();
            if (!is_lgScreen && promoPageNavLinks_visible) {
                toggleMainNav();
            }
        }
    });

    //when mobile menu is open, functionality for scroll and esc key
    const handlerFuncs = {
        keyup: function (event) {
            if (!is_lgScreen && promoPageNavLinks_visible && event.which === 27) {
                event.preventDefault();
                toggleMainNav();
            }
        },
        scroll: function (event) {
            if (!is_lgScreen && promoPageNavLinks_visible) {
                if ($promoPageNavLinks.has(event.target).length === 0 && !$promoPageNavLinks.is(event.target)) {
                    toggleMainNav();
                }
            }
        },
        mousewheel: function (event) {
            if (!is_lgScreen && promoPageNavLinks_visible) {
                if ($promoPageNavLinks.has(event.target).length === 0 && !$promoPageNavLinks.is(event.target)) {
                    toggleMainNav();
                }
            }
        },
        DOMMouseScroll: function (event) {
            if (!is_lgScreen && promoPageNavLinks_visible) {
                if ($promoPageNavLinks.has(event.target).length === 0 && !$promoPageNavLinks.is(event.target)) {
                    toggleMainNav();
                }
            }
        }
    };

    $docContainer.on(handlerFuncs);
    $j(window).on(handlerFuncs);

    //dropdown menus
    $promoPageNavLinks.find('.hasSubMenu').on({
        mouseenter: function () {
            if (is_lgScreen && !likelyMobile) {
                toggleDropDown($j(this));
            }
        },
        mouseleave: function () {
            if (is_lgScreen && !likelyMobile) {
                toggleDropDown($j(this));
            }
        },
        click: function (event) {
            if (!is_lgScreen && $j(this).has(event.target)) {
                toggleDropDown($j(this));
            }
            if (is_lgScreen && likelyMobile) {
                toggleDropDown($j(this));
            }
        }
    });

    $promoPageNavLinks.on({
        mouseleave: function () {
            if (is_lgScreen && !(likelyMobile)) {
                resetDropDowns();
            }
        }
    });
    // end Main nav //

    // prevent Document Title(s) showing when it shouldn't be
    const docTitleElems = document.querySelectorAll(".DocumentTitle");
    if (docTitleElems.length > 0) Array.from(docTitleElems).forEach(docTitleElem => docTitleElem.classList.add("hidden"));

    // end all pages //

    //----------------------------------------------------------------------------------//

    // VIN pages (pId 130) specific //

    if (pId === 130) {
        var isMeta = /&meta=(?=\w+)/i;
        var isBio = /&id=(?=\d+)/i;
        if (theUrl.search(isMeta) !== -1) {
            var metaVal = theUrl.match(/&meta=([A-Za-z0-9]+)/i);
        }
        if (theUrl.search(isBio) !== -1) {
            var bioVal = testForBio(theUrl);
        }

        //Carlos M: hide page title section (section.pageTitle) for VIN pages
        $j('section.pageTitle').attr('style', 'display: none; visibility: hidden;');
        // show Document Title(s)
        if (docTitleElems.length > 0) Array.from(docTitleElems).forEach(docTitleElem => docTitleElem.classList.remove("hidden"));

        // About page specific //
        if (CurrentPage === 'aboutPage') {
            //Carlos M: flexslider options and set-up for timeline
            $j('#sliderTimeline #slider').flexslider({
                animation: "slide",
                animationDuration: 2000,
                directionNav: true,
                prevText: '<span class="fa fa-chevron-left" aria-hidden="true"></span><span class="sr-only">Previous</span>',
                nextText: '<span class="fa fa-chevron-right" aria-hidden="true"></span><span class="sr-only">Next</span>',
                controlsContainer: $j('#sliderTimeline .custom-controls-container'),
                manualControls: $j('#sliderTimeline .custom-controls-container ol li'),
            });
        }
        // end About page specific //

        // Why page specific //
        if (CurrentPage === "whyPage") {
            const vinnersRowElem = document.querySelector(".vinners");
            if (vinnersRowElem) RandomBanner(vinnersRowElem);
        }
        // end Why page specific //

        // Consultants specific //
        if (metaVal && metaVal !== undefined) {
            $j('.pageTitle').attr('style', 'display: block; visibility: visible');

            if (metaVal[1] === 0) makeNavItemActive('Consultants and Editors');
            if (metaVal[1].toLowerCase() === 'rep') makeNavItemActive('Representatives');

            // Specialty and Bio pages //
            if (metaVal[1] > 0) {

                makeNavItemActive('Consultants and Editors');

                // collapsable folder list //
                handleMobileMenuButton();
                // end collapsable folder list //
            }
            // end Specialty and Bio pages //

            // Rep Bio pages //
            if (metaVal[1].toLowerCase() === 'rep' && (bioVal && bioVal.length > 0 && bioVal !== -1)) {
                makeNavItemActive('Representatives');
                handleMobileMenuButton();
            }
            // end Rep Bio pages //

            // Bio pages specific //
            if (bioVal && bioVal.length > 0 && bioVal !== -1) {
                //Carlos M:  - added 7 / 05 / 2017 for tfs#1232
                (function () {
                    var $conLinksElem = $j('#DetailsWrapper.individual #conLinks');

                    $j('#specialtyName a[data-toggle="collapse"]').click(function (event) {
                        event.preventDefault();
                        $conLinksElem.collapse('toggle');
                        return false;
                    });

                    $conLinksElem.on('show.bs.collapse', function () {
                        $j('#DetailsWrapper.individual h2 a.btn span').removeClass('fa-chevron-down').addClass('fa-chevron-up');
                    });
                    $conLinksElem.on('hidden.bs.collapse', function () {
                        $j('#DetailsWrapper.individual h2 a.btn span').removeClass('fa-chevron-up').addClass('fa-chevron-down');
                    });

                    $j('[id*="consList"].row ul li a').each(function (index) {
                        if (testForBio($j(this).attr('href'))[1] === bioVal[1]) {

                            //test to find if con is a rep or associate by finding the name of the category they are listed under
                            //then if they are add the rep or associate text above thier name
                            var repOrAssoc = $j(this).parents('ul').siblings('h3').text().match(/(Representatives)|(Associate Editors)/i);
                            if (repOrAssoc && repOrAssoc !== null && repOrAssoc[0] !== '') {
                                $j('#memberType').attr('style', 'display: block; visibility: visible; margin-top: 20px;').text(repOrAssoc[0].replace(/s$/, ''));
                                $j('h2[id*="bioDoc"]').attr('style', 'margin-top: -15px;');
                            }
                        }
                    });
                }());
            }
            // end Bio pages specific //
        }
        // end Consultants specific //

        if (CurrentPage === 'proudVINnerPage') handleP2BLinks(pId);
    }

    // end VIN pages (pId 130) specific //

    //----------------------------------------------------------------------------------//

    // Student pages (pId 680) specific //

    if (pId === 680) {


        if (CurrentPage === 'homePage') {
            let $testimonialSliderContainer = $j('#testimonialsSlider');
            if ($testimonialSliderContainer) {
                ReactDOM.render(
                    <Testimonials
                        slider
                        title={$testimonialSliderContainer.attr('data-testimonials-slider-title')}
                    />,
                    $testimonialSliderContainer[0]
                );
            }
        }


        if (CurrentPage === 'testimonialsPage') {
            ReactDOM.render(
                <Testimonials />,
                document.getElementsByClassName('testimonials')[0]
            );
        }

        if (CurrentPage === 'membershipPage') {
            //Carlos M: for tfs#13323 hiding join VIN button on membership page in Student pages
            //join and login buttons already on bottom of all Student pages
            $j('section.greyPattern').has('#joinVIN').css({
                display: 'none',
                visibility: 'hidden'
            });
        }
    }

    // end Student pages (pId 680) specific //

    //----------------------------------------------------------------------------------//

    // Home pages specific //

    if (CurrentPage === 'homePage') {

        if (likelyMobile) {
            let ath_holder = document.createElement('div');
            ath_holder.setAttribute('id', 'main-athButtons');
            ath_holder.setAttribute('class', 'action');

            document.getElementsByClassName('navLead')[0].appendChild(ath_holder);

            ReactDOM.render(
                <AddToHomeScreen />,
                ath_holder
            );
        }

        let bannerSlider = null;
        //Carlos M: flexslider options and set-up for home page banners
        if (document.getElementById('bannerSlides') !== null) {
            let sliderSection = document.querySelectorAll('#sliderSection');
            if (sliderSection.length > 1) Array.from(sliderSection).forEach((elem, index) => {
                if (index > 0) $j(elem).hide();
            });
            
            $j(sliderSection[0]).find('#slider').flexslider({
                animation: "fade",
                animationDuration: 99999999999,
                directionNav: false
            });
            bannerSlider = $j(sliderSection[0]).find('#slider');
        }
        else {
            $j('#sliderSection #slider').flexslider({
                animation: "fade",
                animationDuration: 99999999999,
                directionNav: false
            });
            bannerSlider = $j('#sliderSection #slider');
        }

        if (pId === 130 && bannerSlider && false) {
            // disabled for now, awaiting finished animated banners
            // handle slide timings for animated banners
            bannerSlider.flexslider('pause');
            const sliderMeta = bannerSlider.data('flexslider');
            const timingsMS = [
                1600,
                4000,
                8000,
                80000,
                24000,
                10000
            ];
            if (sliderMeta.count === timingsMS.length) {
                let timeOutId;
                
                const goToNextSlide = delay => {
                    timeOutId = window.setTimeout(() => {
                        bannerSlider.flexslider('next');
                        const nextSlide = sliderMeta.currentSlide > 4 ? 0 : sliderMeta.currentSlide + 1;
                        goToNextSlide(timingsMS[nextSlide]);
                    }, delay);
                };

                goToNextSlide(timingsMS[sliderMeta.currentSlide]);
            }
            else {
                bannerSlider.flexslider('play');
            }
        }
        
        //Carlos M: for tfs#13384 adding click functionality to banner slider images (not timeline)
        (function () {
            var $slideLinks = [];
            $j('#sliderSection #slider .slides li a').each(function (index) {
                $slideLinks[index] = $j(this).attr('href');

                if ($slideLinks[index] && $slideLinks[index] !== '#') {
                    var currentStyle = $j(this).parent('li').attr('style');
                    var newStyle = currentStyle + ' cursor: pointer;';
                    $j(this).parent('li').attr('style', newStyle);
                    $j(this).parent('li').click(function (event) {
                        event.preventDefault();
                        window.open($slideLinks[index]);
                    });
                }
            });
        }());

        if (pId === 130) {
            ImageMap('img[usemap]');
        }
    }

    // end Home pages specific //

    //----------------------------------------------------------------------------------//

    // Contact page specific //

    if (CurrentPage === 'contactPage') {
        //because the page title (.pageTitle) is being hidden on all other VIN pages
        $j('.pageTitle').attr('style', 'display: block; visibility: visible');

        if (hashOnPageLoad && hashOnPageLoad === '#email') {
            focusNameInput();
        }

        //Carlos M: for form validation
        var $contactForm = $j('form');
        var $sendBtn = $j('#btnSend');
        var $gcaptcha = $j('#g-recaptcha');
        var $errorHolder = null;

        //rendering and validating captcha, valid if response is recieved from callback
        window.captchaLoadCB = () => {
            grecaptcha.render('g-recaptcha', {
                'sitekey': '6LdJLc8SAAAAAGXxLpsNMaqhR3bgymu-tnnhJkBy',
                'callback': function (response) {
                    if (response && response !== undefined) {
                        checkRequiredElems($gcaptcha, true);
                        if ($j('#hiddenRecaptcha-error') && $j('#hiddenRecaptcha-error').css('display') !== 'none') {
                            $j('#hiddenRecaptcha-error').css('display', 'none');
                        }
                    } else {
                        checkRequiredElems($gcaptcha, false);
                    }
                },
                'expired-callback': function () {
                    checkRequiredElems($gcaptcha, false);
                }
            });
        };

        //setting up required elements for contact form validation
        var requiredElems = [];
        $j('#txtFromName, #txtFromEmail, #txtRegarding, #txtMessage, #g-recaptcha').each(function (index, elem) {
            requiredElems[index] = {
                $elem: $j(elem),
                elemName: $j(elem).attr('name') || $j(elem).attr('id'),
                isValid: false
            };
        });

        //validating required elements (except captcha) and handling UI
        var validator = $contactForm.validate({
            ignore: '.ignore',
            rules: {
                txtFromName: 'required',
                txtFromEmail: {
                    required: true,
                    email: true
                },
                txtRegarding: 'required',
                txtMessage: 'required',
                hiddenRecaptcha: {
                    required: function () {
                        if (!grecaptcha.getResponse() || grecaptcha.getResponse() === undefined || grecaptcha.getResponse() === '') {
                            return true;
                        } else {
                            return false;
                        }
                    }
                }
            },
            messages: {
                txtFromName: 'Please provide your name.',
                txtFromEmail: 'Please provide your email in the format: name@domain.com.',
                txtRegarding: 'Please provide a subject.',
                txtMessage: 'Please send us a message.',
                hiddenRecaptcha: 'Please complete the captcha.'
            },
            highlight: function (element) {
                $j(element).addClass('error').removeClass('valid');
            },
            unhighlight: function (element) {
                $j(element).addClass('valid').removeClass('error');
            },
            success: function (label) {
                label.addClass('valid').html('<span class="sr-only">OK!</span><span class="glyphicon glyphicon-ok" aria-hidden="true"></span>');
            },
            onfocusout: function (element) {
                var $element = $j(element);
                if ($element.valid()) {
                    checkRequiredElems($element, true);
                } else {
                    checkRequiredElems($element, false);
                }
            },
            onkeyup: function (element) {
                var $element = $j(element);
                if ($element.valid()) {
                    checkRequiredElems($element, true);
                } else {
                    checkRequiredElems($element, false);
                }
            },
            invalidHandler: function () {
                if ($errorHolder) $errorHolder.remove();
                $errorHolder = $j('<div id="contactFormErrors"></div>');
                $errorHolder.addClass('visible');
                setErrorMessage();
                $j('#contactVIN #promoForm #btnSend').after($errorHolder);
            }
        });
    }

    // end Contact page specific //

    //----------------------------------------------------------------------------------//

    // helper functions //    

    function checkViewSize() {
        var viewWidth = $docContainer.outerWidth();

        if (viewWidth > scrn_md) {
            if (is_lgScreen === false) {
                resetDropDowns();
                $promoPageNavLinks.css('height', '39px');
            }

            //Carlos M: making main nav open for "desktop" screen sizes, hidden by default
            if (!promoPageNavLinks_visible) {
                toggleMainNav('show');
            }

            HeaderUtils.setHeaderHeight();

            is_lgScreen = true;

        } else {
            if (is_lgScreen) {
                resetDropDowns();
                $promoPageNavLinks.css('height', '100%');
                toggleMainNav('hide');
            }

            HeaderUtils.setHeaderHeight();
            is_lgScreen = false;
        }      
        
    }

    function scrollFn() {
        if ($j(this).scrollTop() > 0) {
            $header.css('position', 'fixed');
            $j('header, header .menuControl').addClass('border-bottom');
        } else {
            $header.css('position', 'absolute');
            $j('header, header .menuControl').removeClass('border-bottom');  
        }
        
    };

    // Consultants and Reps //
    function testForBio(testString) {
        return testString.match(/&id=([0-9]+)/i);
    }

    function handleMobileMenuButton() {

        if ($j('#MobileMemberNavList').css('display', 'block')) {
            let $menuControl = $j('#MobileMemberNavList .btnHolder a[data-toggle="collapse"]');
            
            $menuControl.click(function (event) {
                event.preventDefault();
                $j('#mobileConsFolderList').collapse('toggle');
                return false;
            });
        }
    }
    // end Consultants and Reps //

    
    function openEmailClient(event) {
        event.preventDefault();
        var target = $j(event.target).attr('data-target');
        var domain = $j(event.target).attr('data-domain');
        if ((target !== null && target !== '') && (domain !== null && domain !== '')) {
            if (tempWindow === null || tempWindow.closed) {
                tempWindow = window.open('mailto:' + target + '@' + domain + '.' + ((domain === 'vspn') ? 'org' : 'com'));
                tempWindow.opener = self;
                tempWindow.setTimeout(function () {
                    tempWindow.close();
                }, 100);
            } else {
                tempWindow.close();
                openEmailClient(event);
            }
        }
        return false;
    }

    // Contact //

    function goToContactPage(event) {
        event.preventDefault();
        if (CurrentPage === 'contactPage') {
            focusNameInput();
        }
        else {
            location.assign(`/vin/default.aspx?pId=${pId}&id=0&meta=ContactVIN#email`);
        }      
    }

    function focusNameInput() {
        let nameInput = document.getElementById('txtFromName');
        if (nameInput != null) {
            //wait before focusing input element to support IE
            setTimeout(() => {
                nameInput.focus();
            }, 100);
        }
        else {
            if (document.getElementById('messageResult'))
                location.assign(`/vin/default.aspx?pId=${pId}&id=0&meta=ContactVIN#email`);
        }
    }

    //checks all required form elements for validity, if all are valid, removes inValid class from send button
    function checkRequiredElems($elem, isValid) {
        var elemName = $elem.attr('name') || $elem.attr('id');
        var allElemsValid = true;
        for (let i = 0; i < requiredElems.length; i++) {
            if (isValid) {
                if (requiredElems[i].elemName === elemName) {
                    requiredElems[i].isValid = true;
                } else {
                    if (!requiredElems[i].isValid) allElemsValid = false;
                }
            } else {
                if (requiredElems[i].elemName === elemName) {
                    requiredElems[i].isValid = false;
                }
                allElemsValid = false;
            }
        }
        if (allElemsValid) {
            if ($sendBtn.hasClass('inValid')) $sendBtn.removeClass('inValid');
            if ($errorHolder) $errorHolder.remove();
        } else {
            if (!$sendBtn.hasClass('inValid')) $sendBtn.addClass('inValid');
            if ($errorHolder && $errorHolder.hasClass('visible')) setErrorMessage();
        }
    }

    function setErrorMessage() {
        var errorMsg = validator.numberOfInvalids() === 1 ? 'There is <span class="badge">1</span> error, it is indicated.' : 'There are <span class="badge">' + validator.numberOfInvalids() + '</span> errors, they are indicated';
        $errorHolder.html('<p>' + errorMsg + '</p>');
    }
    // end Contact //

    // Jump links //
    function jumpToLink(jumpTarget) {
        
        let $jumpTarget = $j('#' + jumpTarget);

        if ($jumpTarget.length > 0) {
            let initPageScroll = Math.round($docContainer[3].scrollTop);
            let jumpLocation = Math.round($jumpTarget.offset().top);

            Anime({
                targets: [document.querySelector('html'), document.body],
                scrollTop: initPageScroll + (jumpLocation - (HeaderUtils.getHeaderHeight() + 10)),
                duration: 200,
                easing: 'linear'
            });
        }
    }
    // end Jump links //

    // Main nav //
    function makeNavItemActive(item) {
        $promoPageNavLinks.find('li').each(function () {
            if (!$j(this).hasClass('hasSubMenu')) {
                if (this.innerText.match(item)) $j(this).addClass('active');
            }
        });
    }

    function toggleMainNav(disp) {
        if (disp && disp !== null && disp !== '') {
            if (disp === 'show' && !promoPageNavLinks_visible) {
                $promoPageNavLinks.show();
                promoPageNavLinks_visible = true;
            }
            if (disp === 'hide' && promoPageNavLinks_visible) {
                $promoPageNavLinks.hide();
                promoPageNavLinks_visible = false;
            }
        } else {
            if (!promoPageNavLinks_visible) {
                $docContainer.removeClass(managedOverflowClass).addClass(noOverFlowClass);
                $header.addClass(managedOverflowClass);
                $promoPageNavLinks.slideDown();
                mainNav.classList.add(managedOverflowClass);
                promoPageNavLinks_visible = true;
            } else {
                $docContainer.addClass(managedOverflowClass).removeClass(noOverFlowClass);
                $header.removeClass(managedOverflowClass);
                $promoPageNavLinks.slideUp();
                mainNav.classList.remove(managedOverflowClass);
                promoPageNavLinks_visible = false;
            }
        }
    }

    function toggleDropDown($ddParent) {
        var $dropdown = $ddParent.children('.subMenu');
        var $chevron = $ddParent.children('a').children('span.glyphicon');

        $chevron.toggleClass('glyphicon-chevron-down').toggleClass('glyphicon-chevron-up');

        if ($ddParent.hasClass('open')) {
            $ddParent.removeClass('open');
        }
        else {
            $ddParent.addClass('open');
        }

        if ($dropdown.hasClass('open')) {
            $dropdown.removeClass('open');
        }
        else {
            $dropdown.addClass('open');
        }

        if (!is_lgScreen) {
            $dropdown.slideToggle(400, function () {
                $promoPageNavLinks.css('height', '100%');
                
                if ($header.outerHeight() >= $j(window).height()) {
                    $j('a.back-to-top').hide();
                }
                else if ($header.outerHeight() < $j(window).height()) {
                    $j('a.back-to-top').show();
                }
            });
        } else {
            $dropdown.toggle();
        }
    }

    function resetDropDowns() {
        $j('#promoPageNavLinks .hasSubMenu, #promoPageNavLinks .hasSubMenu .subMenu').each(function (index, elem) {
            if ($j(elem).hasClass('open')) {
                $j(elem).removeClass('open');
            }
        });

        $j('#promoPageNavLinks .hasSubMenu .subMenu').each(function (index, elem) {
            $j(elem).hide();
        });
    }
    // end Main nav //
    // end helper functions //

    //----------------------------------------------------------------------------------//
});